module.exports = require("./shi-Latn.js");